export const I = {
  array: <T>(arr: T[]) => ([] as T[]).concat(arr || []),
  record: <T>(obj: Record<string, T>) => ({ ...obj })
};
